export default __webpack_public_path__ + "static/media/LandingDevice2.30660c40.png";